import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import ConferenceCard from './ConferenceCard';

const ConferenceGrid = ({ conferences, loading, filtered = false, onClearFilters }) => {
  const { t } = useTranslation('conferences');

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {[...Array(6)]?.map((_, index) => (
          <div
            key={index}
            className="bg-card border border-border overflow-hidden animate-pulse"
          >
            <div className="h-28 bg-muted"></div>
            <div className="p-4 space-y-3">
              <div className="h-4 bg-muted w-3/4"></div>
              <div className="h-3 bg-muted w-full"></div>
              <div className="h-3 bg-muted w-5/6"></div>
              <div className="space-y-2 pt-1">
                <div className="h-3 bg-muted w-2/3"></div>
                <div className="h-3 bg-muted w-1/2"></div>
              </div>
              <div className="h-8 bg-muted w-full mt-2"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (conferences?.length === 0) {
    /* §4, empty state: name the filter that caused the emptiness and offer
       clearing it as the primary action. The old copy said "no conferences
       found" in both cases, which reads as "this board is empty" when in fact
       you had narrowed it to nothing — two very different situations, and only
       one of them is your own doing. */
    return (
      <div className="bg-card border border-border p-10 md:p-16 text-center">
        <div className="max-w-md mx-auto space-y-4">
          <div className="w-16 h-16 mx-auto bg-muted flex items-center justify-center">
            <Icon name={filtered ? 'FilterX' : 'SearchX'} size={30} className="text-muted-foreground" />
          </div>
          <h3 className="text-xl font-heading font-bold text-foreground">
            {filtered
              ? t('publicBoard.empty.filteredTitle', 'No conferences match your filters')
              : t('publicBoard.empty.title')}
          </h3>
          <p className="text-sm text-muted-foreground">
            {filtered
              ? t('publicBoard.empty.filteredSubtitle', 'Your filters are hiding everything on this tab. Clearing them brings the full list back.')
              : t('publicBoard.empty.subtitle')}
          </p>
          {filtered && onClearFilters && (
            <div className="pt-1">
              <Button variant="default" size="default" onClick={onClearFilters} iconName="X" iconPosition="left">
                {t('publicBoard.clearAll')}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {conferences?.map((conference) => (
        <ConferenceCard key={conference?.id} conference={conference} />
      ))}
    </div>
  );
};

export default ConferenceGrid;
